import React from "react"

import { LinearProgress } from "@mui/material"
import { LinearProgressProps } from "@mui/material/LinearProgress/LinearProgress"
import { styled } from "@mui/material/styles"

interface IProps extends LinearProgressProps {
  value: number
}

export const ProgressBar = ({ value, ...props }: IProps) =>
  <StyledProgress
    variant="determinate"
    value={value}
    {...props}
  />

const StyledProgress = styled(LinearProgress)(({ color }) => ({
  backgroundColor: "#C4CEC7",
  width: "100%",

  ...color === "error" && error
}))

const error = {
  "& .MuiLinearProgress-bar": {
    backgroundColor: "#DF4C47"
  }
}
